<template>
  <div class="newtask-root-container">
    <p class="newtask-desc">
      游用工里程碑事件指当您认为或者工作者自身认为工作达到了满意状态时所对应的付款节点，这里包含了与付款相关的工作证明、附件以及支付列表等信息。里程碑事件可以由雇主方和灵工方创建
    </p>

    <span style="font-size: 15px; font-weight: bold; margin-top: 30px"
      >选择事件模板</span
    >

    <div class="newtask-main-container">
      <div class="newtask-item-container" @click="createMilestone">
        <img :src="icons.payConfirm" />
        <span class="newtask-item-title">付款确认单</span>
        <p>
          使用付款确认单模版批量创建对工作者的付款计划，在付款计划被提交至处理队列之前，您可以随时修改付款确认单的内容
        </p>
      </div>
    </div>

    <new-milestone-modal ref="newMilestoneModal" />
  </div>
</template>

<script>
import NewMilestoneModal from "./Modal/NewMilestoneModal";
import * as icon from "../../common/icon";
export default {
  components: {
    "new-milestone-modal": NewMilestoneModal,
  },
  data() {
    return {
      icons: icon,
    };
  },
  methods: {
    createMilestone() {
      this.$refs.newMilestoneModal.open(-1);
    },
  },
};
</script>

<style scoped>
.newtask-root-container {
  display: flex;
  flex-direction: column;
}
.newtask-desc {
  width: 800px;
  background-color: #fcf9eb;
  padding: 20px;
  border-radius: 10px;
}
.newtask-main-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 30px;
  padding: 10px;
}
.newtask-item-container {
  width: 300px;
  height: 350px;
  background-color: white;
  transition: all 0.2s ease;
  border-radius: 13px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px;
}
.newtask-item-container:hover {
  box-shadow: 0px 0px 10px #dddddd;
  transform: translateY(-2px);
}
.newtask-item-title {
  font-size: 23px;
  font-weight: bold;
  margin: 20px 0;
}
</style>